module.exports = __webpack_public_path__ + "static/taxi-2-b547fa37faba438ff773f492dd47f212.png";